export default "__VITE_ASSET__2c85e20e__"